// extracted by mini-css-extract-plugin
export default {"tabs":"AskTeacherMain_tabs__XyEbv","ske":"AskTeacherMain_ske__WGNj7"};